import React from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Button, FormGroup, Label, Input, Row, Col } from "reactstrap";

const validationSchema = Yup.object().shape({
    customerName: Yup.string().required("Customer Name is required"),
    mobileNumber: Yup.string().required("Mobile Number is required"),
    address: Yup.string().required("Address is required"),
    gstNumber: Yup.string().required("GST Number is required"),
    creditLimit: Yup.number().required("CreditLimit required").positive("CreditLimit should be positive"),
    city: Yup.string().required("City is required"),
    pinCode: Yup.string().matches(/^\d{6}$/, "Pincode must be a 6-digit numeric value").required("Pincode is required"),

});

export default function AddPartyForm({ addParty, onChangeForm, values }) {
    return (
        <Formik
            initialValues={{
                customerName: "",
                mobileNumber: "",
                address: "",
                gstNumber: "",
                creditLimit: "",
                city: "",
                pinCode: "",
            }}
            validationSchema={validationSchema}
            onSubmit={(values, { resetForm }) => {
                addParty(values);
                resetForm();
            }}
        >
            {({ errors, touched, resetForm }) => (
                <Form>
                    <Row>
                        <Col md={6}>
                            <FormGroup>
                                <Label for="customerName">Customer Name</Label>
                                <Field
                                    name="customerName"
                                    as={Input}
                                    type="text"
                                    id="customerName"
                                    placeholder="Customer Name"
                                />
                                {errors.customerName && touched.customerName && (
                                    <div className="text-danger">{errors.customerName}</div>
                                )}
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <Label for="mobileNumber">Mobile Number</Label>
                                <Field
                                    name="mobileNumber"
                                    as={Input}
                                    type="text"
                                    id="mobileNumber"
                                    placeholder="Mobile Number"
                                />
                                {errors.mobileNumber && touched.mobileNumber && (
                                    <div className="text-danger">{errors.mobileNumber}</div>
                                )}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <FormGroup>
                                <Label for="address">Address</Label>
                                <Field
                                    name="address"
                                    as={Input}
                                    type="textarea"
                                    id="address"
                                    placeholder="Address"
                                />
                                {errors.address && touched.address && (
                                    <div className="text-danger">{errors.address}</div>
                                )}
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <Label for="city">City</Label>
                                <Field
                                    name="city"
                                    as={Input}
                                    type="text"
                                    id="city"
                                    placeholder="City"
                                />
                                {errors.city && touched.city && (
                                    <div className="text-danger">{errors.city}</div>
                                )}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <FormGroup>
                                <Label for="pincode">Pincode</Label>
                                <Field
                                    name="pinCode"
                                    as={Input}
                                    type="text"
                                    id="pinCode"
                                    pattern="\d{6}"
                                    placeholder="pinCode"
                                    title="Pincode must be a 6-digit number"
                                />
                                {errors.pinCode && touched.pinCode && (
                                    <div className="text-danger">{errors.pinCode}</div>
                                )}
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <Label for="gstNumber">GST Number</Label>
                                <Field
                                    name="gstNumber"
                                    as={Input}
                                    type="text"
                                    id="gstNumber"
                                    placeholder="GST Number"
                                />
                                {errors.gstNumber && touched.gstNumber && (
                                    <div className="text-danger">{errors.gstNumber}</div>
                                )}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <FormGroup>
                                <Label for="creditLimit">Credit Limit</Label>
                                <Field
                                    name="creditLimit"
                                    as={Input}
                                    type="number"
                                    id="creditLimit"
                                    placeholder="Credit Limit"
                                />
                                {errors.creditLimit && touched.creditLimit && (
                                    <div className="text-danger">{errors.creditLimit}</div>
                                )}
                            </FormGroup>
                        </Col>


                    </Row>
                    <Row className="justify-content-center mt-4">
                        <Col md="auto">
                            <Button type="submit" color="primary" className="mr-2">
                                Submit
                            </Button>
                            <Button onClick={() => resetForm()} type="button" color="warning">
                                Cancel
                            </Button>
                        </Col>
                    </Row>
                </Form>
            )}
        </Formik>
    );
}


// WEBPACK FOOTER //
// ./src/components/CustomComponents/AddPartyForm.js